(function () {
  var propertyName = 'properties[_Aperçu configuré]';
  var markerPrefix = 'lbd-configured:';
  var storagePrefix = 'lbd-configured-preview:';
  var captureTimer = 0;

  function storageKey(reference) {
    return storagePrefix + reference;
  }

  function previewInput(form) {
    var input = form.querySelector('[data-lbd-preview-url]');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    input.dataset.lbdPreviewUrl = 'true';
    form.appendChild(input);
    return input;
  }

  function captureConfiguredPreview() {
    var root = document.querySelector('.lbd-configurator');
    if (!root) return;
    var canvas = root.querySelector('canvas[data-lbd-render]');
    var form = root.querySelector('#lbd-configurator-form');
    var referenceInput = root.querySelector('[data-lbd-reference]');
    if (!canvas || !form || !referenceInput || !referenceInput.value || canvas.dataset.error === 'true') return;

    try {
      var imageUrl = canvas.toDataURL('image/jpeg', 0.9);
      if (!imageUrl || imageUrl === 'data:,') return;
      localStorage.setItem(storageKey(referenceInput.value), imageUrl);
      previewInput(form).value = markerPrefix + referenceInput.value;
      root.dataset.cartPreview = referenceInput.value;
    } catch (error) {
      root.dataset.cartPreviewError = 'capture';
    }
  }

  function scheduleCapture() {
    clearTimeout(captureTimer);
    captureTimer = window.setTimeout(captureConfiguredPreview, 180);
  }

  function restoreCartPreviews(scope) {
    var root = scope || document;
    var images = root.querySelectorAll('img[src^="lbd-configured:"]');
    Array.prototype.forEach.call(images, function (image) {
      var reference = image.getAttribute('src').slice(markerPrefix.length);
      var imageUrl = localStorage.getItem(storageKey(reference));
      if (!imageUrl) {
        image.dataset.lbdConfiguredPreview = 'missing';
        return;
      }
      image.src = imageUrl;
      image.removeAttribute('srcset');
      image.dataset.lbdConfiguredPreview = reference;
    });
  }

  function mountProductCapture() {
    var root = document.querySelector('.lbd-configurator');
    if (!root || root.dataset.cartPreviewListener === 'true') return;
    root.dataset.cartPreviewListener = 'true';
    var metal = root.querySelector('[data-lbd-metal]');
    var acrylic = root.querySelector('[data-lbd-acrylic]');
    if (metal) metal.addEventListener('change', scheduleCapture);
    if (acrylic) acrylic.addEventListener('change', scheduleCapture);
    scheduleCapture();
  }

  function mount() {
    mountProductCapture();
    restoreCartPreviews(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches('img[src^="lbd-configured:"]')) restoreCartPreviews(node.parentElement || node);
        else restoreCartPreviews(node);
      });
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id === 'lbd-configurator-form') captureConfiguredPreview();
  }, true);
})();
